import React from 'react';

import './styles.css';

export default function Card(props) {
    return (
        <div className={'card-component' + (props.className ? ` ${props.className}` : "")} id={props.id}>
            <div className='card-component-header'>
                <div className='card-component-header-tittle'>
                    {props.icon ? props.icon : null}

                    <div>
                        <h4><b>{props.tittle}</b></h4>
                        {
                            props.subtittle ?
                                <h5>{props.subtittle}</h5>
                                : null
                        }
                    </div>
                </div>

                <div className='card-component-header-options'>
                    {props.options}
                </div>
            </div>
            {
                props.children ?
                    <div className='card-component-body'>
                        {props.children}
                    </div>
                    : null
            }
        </div>
    )
}